export default {
  activeCart: null,
  activeRetailCart: null,
  activeContainerCart: null,
  loaded: false,
  cartStockQty: 0,
  cartRetailQty: 0,
  cartContainerQty: 0,
  currentStoreType:"retail",
  cartItemsTracker:{}
}
